const ProgrammeIntegrated = ({language , token}) => {
    const newProgrammeIframe = "https:" +
    window.process.env.URL_Programme
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_Programme_display"
        src={newProgrammeIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default ProgrammeIntegrated